import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    error: 'An error occurred. Please try again.',
  },
  fr: {
    error: 'Une erreur est survenue. Veuillez réessayer.',
  },
} as const);
export default locales;
